<template>
    <el-row class="tasks-wrapper">
        <ul class="tasks-filters tab-submenu">
            <li
                v-for="filter in taskFilters"
                :key="filter.title"
                :class="['task-section-title', { active: currentFilter === filter.alias }, { relevant: taskCounters[filter.alias] !== 0 }]"
                @click="setFilter(filter)"
            >
                <span>
                    {{ filter.title }}
                </span>
            </li>
        </ul>

        <div class="mobile-wrapper">
            <div class="tasks-list-wrapper" v-if="allTasks.tasks.length>0">
                <div
                    class="task-item card"
                    v-for="task in allTasks.tasks"
                    :key="task.id"
                    @click="goToTask(task.id)"
                >
                    <div class="task-item-title task-item-row">
                        {{ task.title }}
                    </div>
                    <div class="task-item-id task-item-row">
                        <div class="label">
                            Id:
                        </div>
                        <div class="value">
                            {{ task.id }}
                        </div>
                    </div>
                    <div class="task-item-status task-item-row">
                        <div class="label">
                            Статус:
                        </div>
                        <div class="value">
                            {{ task.status.name }}
                        </div>
                    </div>
                    <div class="task-item-date task-item-row">
                        <div class="label">
                            Дата:
                        </div>
                        <div class="value">
                            {{ task.created_at }}
                        </div>
                    </div>
                    <div class="task-item-executor task-item-row">
                        <div class="label">
                            Исполнитель:
                        </div>
                        <div class="value">
                            {{ task.assigned_user.full_name }}
                        </div>
                    </div>
                    <div class="task-item-planned task-item-row" v-if="task.planned">
                        <div class="label">
                            Срок:
                        </div>
                        <div class="value">
                            {{ task.planned }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="card no-tasks" v-else>
                {{ this.noTaskMsg }}
            </div>
        </div>
    </el-row>
</template>

<script>
import localReferences from '@/helpers/localReferences';

export default {
    name: 'TasksMobile',
    props: {
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            entityType: 'deal',
            taskFilters: [],
            currentFilter: 'my',
            loading: false,
            noTaskMsg: 'Список пуст',
            taskCounters: {
                my: null,
                check: null,
                work: null,
                finished: null
            }
        };
    },
    methods: {
        getFilteredTasks(filter) {
            const requestParams = {
                filter: {
                    ...{
                        related_entity_type: this.entityType,
                        related_entity_id: this.dealId
                    },
                    ...filter
                },
                sort: [
                    { colId: 'status_id', sort: 'asc' },
                    { colId: 'created_at', sort: 'desc' }
                ]
            };
            this.loading = true;
            this.$store.dispatch('tasks/getTasksFiltered', requestParams).then(
                response => {
                    this.loading = false;
                }).catch(
                error => {
                    console.log(error);
                });
        },
        setFilter(value) {
            this.currentFilter = value.alias;
            this.getFilteredTasks(value.filter);
        },
        goToTask(id) {
            const route = {
                name: 'task-card',
                params: { id: id }
            };

            this.$router.push(route);
        },
        async getTasksCounters(entityType, entityId) {
            if (entityId === null || entityId === 'null' || !entityId) {
                this.$notify({ title: 'Ошибка', message: `Не удалось обновить метрики по задачам сделки  ${entityId}`, type: 'error', duration: 60000 });
                return;
            }
            const params = {
                entityType,
                entityId,
                counters: this.taskFilters.map(filter => filter.alias)
            };
            try {
                const response = await this.$store.dispatch('tasks/getTaskRelatedMetric', params);
                this.taskCounters = response.data;
            } catch (e) {
                console.log(e);
            }
        }
    },
    computed: {
        allTasks() {
            return this.$store.state.tasks;
        },
        currentUserId() {
            return this.$store.state.auth.id;
        },
        filterPreset() {
            return this.taskFilters.filter(item => item.alias === this.currentFilter)[0].filter;
        }
    },
    beforeMount() {
        this.getFilteredTasks(this.filterPreset);
        this.getTasksCounters(this.entityType, this.dealId);
    },
    created() {
        this.taskFilters = [
            {
                alias: 'my',
                title: 'мои',
                filter: {
                    assigned_user_id: [this.currentUserId],
                    status_id: [localReferences.taskStatuses.assigned]
                }
            },
            {
                alias: 'check',
                title: 'проверить',
                filter: {
                    created_user_id: [this.currentUserId],
                    status_id: [localReferences.taskStatuses.onCheck]
                }
            },
            {
                alias: 'work',
                title: 'в работе',
                filter: {
                    status_id: [localReferences.taskStatuses.assigned],
                    notEqual: {
                        assigned_user_id: this.currentUserId
                    }
                }
            },
            {
                alias: 'finished',
                title: 'завершены',
                filter: {
                    status_id: [localReferences.taskStatuses.finished]
                }
            }
        ];
    }
};
</script>
